const LOGIN_TOKEN_KEY = 'erxesLoginToken';
const LOGIN_REFRESH_TOKEN_KEY = 'erxesLoginRefreshToken';

var CHAT_URL = 'http://localhost:3200/chatbot.html';
var DASHBOARD_URL;
var REACT_APP_API_SUBSCRIPTION_URL;
var REACT_APP_API_URL;
var REACT_FS_SERVER_HOST;
var email;
var password;
var userID;
export default {
  LOGIN_TOKEN_KEY,
  LOGIN_REFRESH_TOKEN_KEY
};



// WEBPACK FOOTER //
// ./src/consts.js